/* eslint-disable react-hooks/exhaustive-deps */
import './App.scss';

import React, {useEffect, useState} from 'react';
import {batch, useDispatch, useSelector} from 'react-redux';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import {AppContext} from './lib/contexLib';
import {deleteCookie, getCookie} from './lib/cookieHelper';
import {GetRequest} from './lib/AxiosHelper';
import {updateHeaders} from './lib/AxiosConfig';
import {ALERT_VARIANT, COOKIE_AUTHTOKEN} from './const/dataEnum';
import {API_AUTHACTION_ME, API_EMPLOYEE_ME} from './const/Api';
import {setAlert} from './stores/actions/alertModalStateAction';
import {logout, setAuthToken, setAvailableMenu, setUserInfo} from './stores/actions/appStateAction';
import LayoutDashboard from './components/layouts/LayoutDashboard';
import AlertLayout from './components/layouts/AlertLayout';
import Login from './pages/Login/Login';
import {MenuData} from './components/MenuBar/MenuData';
import {getCookieRemainingTime, getSwVersion, sessionExpired} from './stores/business/appBusiness';

function App() {
  const dispatch = useDispatch();
  const {authtoken, menu} = useSelector((state) => ({
    authtoken: state.appState.authtoken,
    menu: state.appState.menu,
  }));
  const [isAuthenticating, setIsAuthenticating] = useState(true);

  useEffect(() => {
    window.process = {
      ...window.process,
    };
    document.title = 'Formulatrix Employee Support System';
    let loggedIn = getCookie(COOKIE_AUTHTOKEN);
    if (loggedIn) {
      batch(() => {
        dispatch(setAuthToken(loggedIn));
        dispatch(updateHeaders());
        GetRequest(dispatch, API_EMPLOYEE_ME).then((myData) => {
          if (myData.data.responseCode === 0) {
            dispatch(setUserInfo(myData.data.data[0]));
            GetRequest(dispatch, API_AUTHACTION_ME).then((myActions) => {
              if (myActions.data.responseCode === 0) {
                dispatch(setAvailableMenu(myActions.data.data));
              } else if (myActions.data.responseCode < -1) {
                dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: myActions.data.message}));
                deleteCookie(COOKIE_AUTHTOKEN);
                dispatch(logout());
                localStorage.clear();
              }
            });
          } else if (myData.data.responseCode < -1) {
            dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: myData.data.message}));
            deleteCookie(COOKIE_AUTHTOKEN);
            dispatch(logout());
            localStorage.clear();
          }
        });
      });
    } else {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: 'Your session has expired'}));
      batch(() => {
        dispatch(logout());
        dispatch(updateHeaders());
      });
    }
    setIsAuthenticating(false);

    return () => {
      deleteCookie(COOKIE_AUTHTOKEN);
    };
  }, []);

  useEffect(() => {
    // if cookie is expired redirect to login or logout
    let timeout = null;
    if (authtoken) {
      timeout = setTimeout(() => {
        sessionExpired(dispatch);
      }, getCookieRemainingTime());
    } else {
      clearTimeout(timeout);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [authtoken]);

  useEffect(() => {
    getSwVersion(dispatch);
  }, []);

  return (
    <>
      {!isAuthenticating && (
        <Router exact basename={global.config.basePath}>
          <AppContext.Provider value={{}}>
            <AlertLayout>
              <Switch>
                <Route path="/Login">{authtoken !== undefined ? <Redirect to="/"/> : <Login/>}</Route>
                <Route>
                  {authtoken === undefined ? <Redirect to="/Login" key="login"/> : ''}
                  <LayoutDashboard>
                    {authtoken &&
                      menu.map((m, i) => {
                        var menuDetail = MenuData.find((md) => md.id === m.id);
                        if (menuDetail) return menuDetail.route;
                        else return null;
                      })}
                  </LayoutDashboard>
                </Route>
              </Switch>
            </AlertLayout>
          </AppContext.Provider>
        </Router>
      )}
    </>
  );
}

export default App;
